import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '../common';
import './SpadeInfoModal.css';

/**
 * "What is a Spade?" informational modal.
 *
 * Explains Polar Ace's virtual currency to new users.
 * Triggered by clicking the spade icon (♠) in the nav bar.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether modal is visible
 * @param {function} props.onClose - Handler to close the modal
 * @param {function} props.onGetSpades - Handler to open the purchase modal
 * @returns {JSX.Element}
 */
function SpadeInfoModal({ isOpen, onClose, onGetSpades }) {
  const handleGetSpades = () => {
    onClose();
    onGetSpades();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="What is a Spade?" className="spade-info-modal">
      <div className="spade-info-modal__content">
        {/* Large animated spade icon */}
        <div className="spade-info-modal__icon-container">
          <span className="spade-info-modal__icon">♠</span>
        </div>

        {/* Description */}
        <p className="spade-info-modal__description">
          Spades are Polar Ace's virtual currency.
          <br />
          Use them to:
        </p>

        {/* Benefits list */}
        <ul className="spade-info-modal__benefits">
          <li>
            <span className="spade-info-modal__bullet">♠</span>
            <span>Go Live! with your favorite streamers</span>
          </li>
          <li>
            <span className="spade-info-modal__bullet">♠</span>
            <span>Send messages to creators</span>
          </li>
          <li>
            <span className="spade-info-modal__bullet">♠</span>
            <span>Unlock exclusive content</span>
          </li>
          <li>
            <span className="spade-info-modal__bullet">♠</span>
            <span>Support streamers directly</span>
          </li>
        </ul>

        {/* CTA Button */}
        <button
          type="button"
          className="spade-info-modal__cta"
          onClick={handleGetSpades}
        >
          Get Spades Now
        </button>
      </div>
    </Modal>
  );
}

SpadeInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onGetSpades: PropTypes.func.isRequired,
};

export default SpadeInfoModal;
